import React from 'react'

const Logo = ({ ...props }) => {
	return (
		<svg
			{...props}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 596 200"
			fill="currentColor"
		>
			<path d="M300.42,78.34c-2.85-2.36-6.44-4.16-10.77-5.43s-9.44-1.9-15.32-1.9h-20.14v54.92l20.21,0.04
	c5.88,0,10.99-0.7,15.32-2.09c4.33-1.39,7.92-3.33,10.75-5.8s4.94-5.4,6.33-8.79c1.38-3.38,2.07-7.07,2.07-11.05
	c0-4.19-0.7-7.97-2.09-11.33C305.39,83.55,303.27,80.69,300.42,78.34L300.42,78.34z M295.87,105.69c-0.84,2.23-2.1,4.12-3.78,5.69
	s-3.77,2.78-6.27,3.64c-2.51,0.86-5.42,1.28-8.75,1.28h-11.74V80.7h11.74c3.33,0,6.24,0.41,8.75,1.23s4.6,1.98,6.27,3.5
	c1.67,1.51,2.93,3.35,3.78,5.52c0.84,2.17,1.27,4.6,1.27,7.29S296.72,103.46,295.87,105.69L295.87,105.69z"/>
			<path d="M341.51,71.01l-25.79,54.92h11.74l4.25-9.24h32.08l4.39,9.24h11.7l-26.57-54.92H341.5L341.51,71.01z
	 M335.96,107.52l11.56-24.95l11.88,24.95H335.96z"/>
			<path d="M439.18,95.19c2.2-2.62,3.3-5.68,3.3-9.17c0-2.13-0.43-4.12-1.28-5.96c-0.85-1.84-2.16-3.43-3.92-4.76
	c-1.76-1.34-3.97-2.38-6.62-3.14c-2.66-0.76-5.78-1.14-9.36-1.14h-29.34v54.92h33.56c3.61,0,6.74-0.39,9.4-1.18
	c2.66-0.78,4.86-1.91,6.61-3.37s3.05-3.23,3.9-5.29c0.85-2.06,1.28-4.37,1.28-6.92c0-3.05-0.62-5.76-1.86-8.15s-3.13-4.33-5.66-5.83
	L439.18,95.19z M403.1,80.81h18.48c3,0,5.28,0.55,6.83,1.63c1.56,1.09,2.34,2.63,2.34,4.62s-0.78,3.63-2.35,5.13
	c-0.91-0.07-1.85-0.11-2.81-0.11H403.1L403.1,80.81L403.1,80.81z M432.63,114.3c-1.56,1.29-3.84,1.93-6.83,1.93h-22.7V101.4h22.7
	c3,0,5.28,0.66,6.83,1.97c1.56,1.31,2.34,3.14,2.34,5.48S434.19,113.01,432.63,114.3L432.63,114.3z"/>
			<path d="M513.09,101.23c1.02-1.55,1.78-3.24,2.27-5.08s0.74-3.78,0.74-5.81c0-3.02-0.5-5.73-1.49-8.12
	c-1-2.39-2.51-4.42-4.55-6.08c-2.04-1.66-4.6-2.93-7.69-3.81s-6.75-1.32-10.96-1.32h-27.94v54.92h11.14v-15.64l16.87,0.04h0.31
	l10.33,15.6h13.63l-11.95-17.57c2.08-0.8,3.9-1.8,5.45-3.01c1.55-1.2,2.83-2.58,3.85-4.13L513.09,101.23z M503.57,94.61
	c-0.53,1.28-1.33,2.36-2.39,3.25c-1.07,0.89-2.39,1.58-3.97,2.07c-1.58,0.49-3.42,0.74-5.53,0.74H474.6V80.71h17.08
	c4.24,0,7.41,0.84,9.52,2.51c2.11,1.68,3.16,4.05,3.16,7.12C504.36,91.91,504.1,93.33,503.57,94.61z"/>
			<path d="M564.4,71.01h-11.81l-25.79,54.92h11.74l4.25-9.24h32.08l4.39,9.24h11.7l-26.57-54.92L564.4,71.01z
	 M547.04,107.52l11.56-24.95l11.88,24.95H547.04z"/>
			<path d="M4.04,37.42l37.42,159.56l159.56-37.42L163.6,0L4.04,37.42L4.04,37.42z M18.53,46.41L147,16.28L77.73,137.74
	l-43.69-25.2L18.53,46.41L18.53,46.41z M50.44,182.48l-12.63-53.84l44.39,25.6l74.53-130.67l29.78,127L50.44,182.48L50.44,182.48z"
			/>
		</svg>

	)
}

export default Logo
